import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const CheckMarkIcon: React.FunctionComponent<IconProps> = ({
  width = 20,
  height = 16,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={20} viewBoxHeight={16} {...rest}>
    <path d="M6.62237 11.1526L17.7855 0L20 2.21453L6.6222 15.5923L0 8.97013L2.22782 6.758L6.62237 11.1526Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/icon/check-mark.icon.tsx